import { render, staticRenderFns } from "./MailIntegrationView.vue?vue&type=template&id=d25230e0"
import script from "./MailIntegrationView.vue?vue&type=script&lang=js"
export * from "./MailIntegrationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports